import { render } from "./AdmHeader.vue?vue&type=template&id=0e4c1b1f&scoped=true"
import script from "./AdmHeader.vue?vue&type=script&lang=js"
export * from "./AdmHeader.vue?vue&type=script&lang=js"

import "./AdmHeader.vue?vue&type=style&index=0&id=0e4c1b1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4c1b1f"]])

export default __exports__